export default "__VITE_ASSET__e59fefb3__"